define('ShippingByLocation.Model', [
  'underscore',
  'Moment',
  'Utils',
  'SCModel',
  'DateCalculations'
], function ShippingByLocationModelModule(_, moment, Utils, SCModelComponent, DateCalculations) {
  'use strict';

  var SCModel = SCModelComponent.SCModel;

  function ShippingByLocationModel(attributes, options) {
    SCModel.call(this, attributes, options);
  }

  ShippingByLocationModel.prototype = Object.create(SCModel.prototype);

  _.extend(ShippingByLocationModel.prototype, {
    constructor: ShippingByLocationModel,

    getId: function getId() {
      return this.get('id');
    },

    getName: function getName() {
      var city = this.get('city');
      var state = this.get('state');
      var name = this.get('name');

      if (city && state) {
        return city + ', ' + state;
      }
      if (city || state) {
        return city || state;
      }
      return name;
    },

    getCutOffTime: function getCutOffTime() {
      var cutOffTime = this.get('cutOffTime');
      var timeZone = this.get('timeZone');

      var hasTz = typeof moment.tz === 'function' && Boolean(timeZone);

      var abbr = '';
      if (hasTz) {
        try {
          abbr = moment.tz.zone(timeZone) ? moment().tz(timeZone).zoneAbbr() : '';
        } catch (e) {
          abbr = '';
        }
      }

      return cutOffTime + (abbr ? ' ' + abbr : '');
    },

    getCutOffTimeData: function getCutOffTimeData() {
      var time = this.get('cutOffTime');
      if (!time) {
        return null;
      }
      return {
        time: this.get('cutOffTime'),
        timeZone: this.get('timeZone') || null
      };
    },

    getCutOffTimeStatus: function getCutOffTimeStatus() {
      var timeData = this.getCutOffTimeData();
      var now = moment();
      var cutOffToday = DateCalculations.getMomentForTimeToday(timeData);
      var cutOffTomorrow = DateCalculations.getMomentForTimeTodayTomorrow(timeData);
      var cutOffMoment;
      var isPast;

      if (!cutOffToday) {
        return null;
      }
      if (cutOffToday && now.isBefore(cutOffToday)) {
        isPast = false;
        cutOffMoment = cutOffToday;
      } else if (cutOffTomorrow) {
        isPast = true;
        cutOffMoment = cutOffTomorrow;
      }
      if (!cutOffMoment) {
        return null;
      }
      cutOffMoment = DateCalculations.getNextBusinessDay(cutOffMoment).moment;
      return {
        isPast: isPast,
        isToday: cutOffMoment.isSame(cutOffToday),
        isTomorrow: Boolean(cutOffTomorrow) && cutOffMoment.isSame(cutOffTomorrow),
        moment: cutOffMoment,
        difference: moment.duration(cutOffMoment.diff(now))
      };
    },

    /**
     * @returns {{ moment: Moment, days: number }|null}
     */
    getEstimatedShippingMin: function getEstimatedShippingMomentMin() {
      var estimatedShippingTimeMin = this.getShippingTimeDaysMinAttr();
      if (!estimatedShippingTimeMin) {
        return null;
      }
      return this.calculateShippingDateForDays(estimatedShippingTimeMin);
    },

    /**
     * @returns {{ moment: Moment, days: number }|null}
     */
    getEstimatedShippingMax: function getEstimatedShippingMomentMax() {
      var estimatedShippingTime = this.getShippingTimeDaysMaxAttr();
      if (!estimatedShippingTime) {
        return null;
      }
      return this.calculateShippingDateForDays(estimatedShippingTime);
    },

    /**
     * @param {number} shippingDaysToAdd
     * @returns {{ moment: Moment, days: number }|null}
     */
    calculateShippingDateForDays: function estimateShippingDateForDays(shippingDaysToAdd) {
      var cutOffTimeStatus = this.getCutOffTimeStatus();
      var initialMoment;
      if (!cutOffTimeStatus) {
        return null;
      }
      initialMoment = moment();
      if (cutOffTimeStatus.isPast) {
        initialMoment = initialMoment.add(1, 'days');
      }
      return DateCalculations.addBusinessDaysToMoment(initialMoment, shippingDaysToAdd);
    },

    getShippingTimeDaysMinAttr: function getShippingTimeDaysMinAttr() {
      return this.get('shippingTimeDays') || null;
    },

    getShippingTimeDaysMaxAttr: function getShippingTimeDaysMaxAttr() {
      return this.get('shippingTimeDaysMax') || null;
    }
  });

  return ShippingByLocationModel;
});
